export default __webpack_public_path__ + "static/media/star.f6c9a868.svg";